import React from 'react';

import SelectionsList from '../SelectionsList/SelectionsList';

import { observer } from 'mobx-react';
import { AppStateComponent } from 'src/AppState/AppState';
import { getMarketList } from './getMarketList';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { TypeId } from 'src_common/common/websocket2/type';


const isPopular = (market: MarketModel): boolean => market.getTag('telebet-popular-market') === 'yes';


interface PropsType {
    userId: number,
    eventId: number,
    onClose: () => void,
}

@observer
class MarketsList extends AppStateComponent<PropsType> {

    openMarket(marketId: TypeId.MarketId) {
        return (e: React.MouseEvent<HTMLAnchorElement>): void => {
            e.preventDefault();

            console.info('open market', marketId);
            this.appState.marketsListState.setMarket(marketId);
        };
    }

    renderPopularMarkets(): React.ReactElement | null | string {
        const { opened } = this.appState.marketsListState;

        if (opened !== null) {
            return null;
        }

        const { eventId } = this.props;

        const eventModel = this.appState.websocketV2.getEvent(eventId);
        if (eventModel === null) {
            return null;
        }

        const popularMarkets = getMarketList(eventModel, (market: MarketModel): boolean => isPopular(market));

        if (popularMarkets.length) {
            const popularElements = [];

            for (const group of popularMarkets) {
                for (const market of group.list) {
                    popularElements.push(
                        <li key={ market.id }>
                            <a href='#' onClick={ this.openMarket(market.id) }>{ market.name }</a>
                        </li>
                    );
                }
            }

            return (
                <ul className='menu'>
                    { popularElements }
                </ul>
            );
        } else {
            return 'There are no popular tags';
        }
    }

    renderDefaultListElements(): Array<React.ReactElement> | null {
        const { eventId } = this.props;

        const eventModel = this.appState.websocketV2.getEvent(eventId);
        if (eventModel === null) {
            return null;
        }

        const markets = getMarketList(eventModel, (market: MarketModel): boolean => !isPopular(market));

        return markets
            .map((group) => (
                <div key={ group.letter }>
                    <h4>{ group.letter }</h4>

                    <ul className='menu'>
                        {
                            group.list
                                .map(market => (
                                    <li key={ market.id }>
                                        <a href='#' onClick={ this.openMarket(market.id) }>{ market.name }</a>
                                    </li>
                                ))
                        }
                    </ul>
                </div>
            ));
    }

    renderSelectionsList(opened: TypeId.MarketId): React.ReactElement | null {
        const { eventId } = this.props;

        return (
            <SelectionsList
                userId={this.props.userId}
                eventId={eventId}
                openedMarket={opened}
            />
        );
    }

    render(): React.ReactElement | null {
        const { opened } = this.appState.marketsListState;

        return (
            <div className='markets-list'>
                <button title='Close Event' className='markets-list__close' onClick={ this.props.onClose }>x</button>

                <div key='popular'>
                    <h4>Popular tags</h4>
                    { this.renderPopularMarkets() }
                </div>

                { opened === null ? this.renderDefaultListElements() : this.renderSelectionsList(opened) }
            </div>
        );
    }
}

export default MarketsList;
